import { useQuery } from "@tanstack/react-query";

import { getService } from "../helpers/isPes";
import newApi from "../newApi";
import options from "./defaultOptions";

export function useGetDiscussion(id, enabled) {
	return useQuery({
		queryKey: [`discussion-${getService()}-${id}`],
		queryFn: () => newApi.getDiscussion(id),
		...options,
		enabled: !!enabled,
		gcTime: 60 * 1000,
	});
}
